// Player saves keep quest progress by position: the index of the current step and the counts of that step's
// objectives (QuestSaveEntry in the game). Moving or deleting those entries in a quest players already have
// puts their progress on another one. Mirrors PROGRESS_LISTS in pocketbase/pb_hooks/lib/data-merge.js.

export const PROGRESS_LISTS: Record<string, string[]> = {
  'EnyaRPG.Quest.QuestData': ['steps'],
  'EnyaRPG.Quest.QuestStepData': ['objectives'],
};

export function isProgressList(f: { owner?: string; name: string }): boolean {
  return !!f.owner && (PROGRESS_LISTS[f.owner] ?? []).includes(f.name);
}
